import { green } from 'utils/style/colors';
import {
  ProgressBarBorder,
  ProgressBarPercent,
  ProgressBarContainer,
} from './styles';
import React from 'react';

interface IComponentProps {
  total: number;
  count: number;
  color?: string;
}

const ProgressBar: React.FC<IComponentProps> = ({
  total,
  count,
  color = `${green}`,
}) => (
  <ProgressBarContainer>
    <ProgressBarBorder>
      <ProgressBarPercent
        percent={Math.floor((count * 100) / total)}
        color={color}
      />
    </ProgressBarBorder>
  </ProgressBarContainer>
);

export default ProgressBar;
